module.exports = __webpack_public_path__ + "img/esplanade_logo.d612d78f.png";